import * as types from "../../actions/actionTypes";

const initialState = {
  preprocesss: [],
  preprocessUpserting: {},
  modalOpened: false,
  configParameters: [],
  requesting: false,
  getDocIdList: [],
  categorieList: [],
  view: "Operations"
};

const preprocessReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_PREPROCESS:
      return { ...state, requesting: true };
    case types.REQUEST_PREPROCESS_SUCCESS:
      return { ...state, requesting: false, preprocesss: action.preprocesss };
    case types.SET_PREPROCESS_UPSERTING: {
      let obj = {};
      if (action.id !== -1) {
        for (let i = 0; i < state.preprocesss.length; i++) {
          if (state.preprocesss[i].id === action.id) {
            obj = state.preprocesss[i];
            break;
          }
        }
      }
      return { ...state, preprocessUpserting: obj };
    }
    case types.OPEN_MODAL_PREPROCESS:
      return { ...state, modalOpened: true };
    case types.CLOSE_MODAL_PREPROCESS:
      return { ...state, modalOpened: false };
    case types.SET_CONFIG_PARAMETERS_PREPROCESS:
      return { ...state, configParameters: action.configParameters };
    case types.SETTINGS_CHANGE_VIEW:
      return { ...state, view: action.view };
    case types.SET_GETDOCIDLIST: {
      let categorieList = [];
      for (let i = 0; i < action.getDocIdList.length; i++) {
        if (categorieList.indexOf(action.getDocIdList[i].categorie) < 0)
          categorieList.push(action.getDocIdList[i].categorie);
      }
      return { ...state, getDocIdList: action.getDocIdList, categorieList };
    }
    case types.CLEAN_GETDOCIDLIST:
      return { ...state, getDocIdList: [], categorieList: [] };
    default:
      return state;
  }
};

export default preprocessReducer;



// WEBPACK FOOTER //
// ./src/reducers/pomui/preprocessReducer.js